export const ROUTE_PATHS = {
    HOME_PATH: '',
    PROOF_OF_IDENTITY: 'proofOfIdentity',
    TAKE_PHOTO_CONTENT: 'takePhotoContent',
    SCAN_DOCUMENT: 'scanDocument',
    ALLOW_CAMERA: 'allowPermissionCamera',
    CAPTURE_PHOTO: 'capturePhoto',
    SELFIE_DOCUMENT: 'selfieDocument',
    SELFIE_PHOTO: 'selfiePhoto',
    CAPTURE_SELFIE_PHOTO: 'captureSelfiePhoto',
    RETAKE_SCREEN: 'retakeScreen',
};
//# sourceMappingURL=routePaths.js.map